export default "__VITE_ASSET__SNOeb_3v__"